<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#3EA56E" left :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <!-- <v-dialog v-model="cancelDialogue" width="400">
      <v-card>
        <v-layout pa-4 wrap justify-center>
          <v-flex xs12>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 18px;
              "
            >
              Do you want to cancel this product ?
            </span>
          </v-flex>
          <v-flex xs12>
            <span
              style="
                color: #000000;
                font-family: opensanssemibold;
                font-size: 14px;
              "
            >
              {{ storage.product.productname }}
            </span>
          </v-flex>
          <v-flex xs6 px-2>
            <v-btn
              tile
              block
              depressed
              dark
              color="#ff1313"
              @click="cancelProduct"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                Yes
              </span>
            </v-btn>
          </v-flex>
          <v-flex xs6 px-2>
            <v-btn
              tile
              block
              depressed
              dark
              color="#1BD93B"
              @click="cancelDialogue = false"
            >
              <span style="font-family: poppinsregular; font-size: 14px">
                No
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog> -->
    <v-row>
      <!-- Product Image -->
      <v-col cols="12" sm="3" md="2" class="d-flex justify-center justify-sm-start">
        <template v-if="storage.productId.photos && storage.productId.photos.length > 0">
          <v-img
            :src="baseURL + 'u/' + storage.productId.photos[0]"
            height="120"
            width="120"
            contain
            class="product-image rounded-lg"
            :alt="storage.productname"
          >
            <template v-slot:placeholder> <ImageLoader /> </template>
          </v-img>
        </template>
        <template v-else>
          <v-img
            :src="require('../../../assets/noimg.png')"
            height="120"
            width="120"
            contain
            class="product-image rounded-lg"
            :alt="storage.productname"
          >
          </v-img>
        </template>
      </v-col>

      <!-- Product Info & Pricing -->
      <v-col cols="12" sm="9" md="10">
        <div class="d-flex flex-column h-full">
          <div class="d-flex align-center justify-space-between flex-wrap">
            <router-link
              :to="'/productdetailview/' + storage.productId.urlname"
              class="text-decoration-none"
            >
              <h3 class="product-name">{{ storage.productname }}</h3>
            </router-link>
            <v-btn  
              v-if="storage.orderStatus !== 'Cancelled By Seller'"
              text
              small
              color="#3EA56E"
              class="track-btn px-2"
              :to="'/trackItem?id=' + storage._id"
            >
              <v-icon left size="16">mdi-map-marker-path</v-icon>
              Track Order
            </v-btn>
          </div>

          <!-- Pricing Grid -->
          <v-row class="mt-4 pricing-grid" no-gutters>
            <v-col cols="6" sm="3" class="mb-2">
              <div class="price-item">
                <span class="p-label">Unit Price</span>
                <span class="p-value">Rs. {{ storage.price }}</span>
              </div>
            </v-col>
            <v-col cols="6" sm="3" class="mb-2">
              <div class="price-item">
                <span class="p-label">Quantity</span>
                <span class="p-value">{{ storage.quantity }} {{ storage.productId.unit }}</span>
              </div>
            </v-col>
            <v-col cols="6" sm="3" class="mb-2">
              <div class="price-item">
                <span class="p-label">Discount</span>
                <span class="p-value text-success">{{ storage.offer }}%</span>
              </div>
            </v-col>
            <v-col cols="6" sm="3" class="mb-2">
              <div class="price-item highlight">
                <span class="p-label">Item Total</span>
                <span class="p-value">Rs. {{ storage.TotalAmount }}</span>
              </div>
            </v-col>
          </v-row>

          <!-- Rating Section -->
          <div v-if="storage.orderStatus == 'Delivered'" class="mt-4 rating-section pa-4 rounded-lg">
            <span class="rating-title d-block mb-2">Rate your experience</span>
            <v-rating
              v-model="storage.productId.rating"
              background-color="#CBD5E1"
              color="#F59E0B"
              dense
              hover
              size="24"
              class="mb-3"
            ></v-rating>
            <v-textarea
              v-model="storage.productId.comment"
              outlined
              dense
              hide-details
              label="Share your thoughts about this product..."
              rows="2"
              class="review-input mb-3"
            ></v-textarea>
            <v-btn
              depressed
              color="#3EA56E"
              dark
              small
              rounded
              class="px-6"
              @click="setRating(storage)"
            >
              Submit Review
            </v-btn>
          </div>

          <!-- Shipment Details -->
          <div
            v-if="storage.shippedService || storage.trackingId"
            class="mt-4 shipment-section pa-4 rounded-lg"
          >
            <div class="d-flex align-center mb-2">
              <v-icon size="18" color="#3B82F6" class="mr-2"
                >mdi-truck-delivery-outline</v-icon
              >
              <span class="shipment-title">Shipment Details</span>
            </div>
            <v-row no-gutters>
              <v-col
                cols="12"
                sm="6"
                v-if="storage.shippedService"
                class="mb-2 mb-sm-0"
              >
                <span class="s-label">Courier Service</span>
                <span class="s-value">{{ storage.shippedService }}</span>
              </v-col>
              <v-col cols="12" sm="6" v-if="storage.trackingId">
                <span class="s-label">Tracking ID</span>
                <span class="s-value">{{ storage.trackingId }}</span>
              </v-col>
            </v-row>
          </div>

          <!-- Refund Details -->
          <div
            v-if="(storage.orderStatus === 'Cancelled' || storage.orderStatus === 'Cancelled By Seller') && (storage.refundStatus || storage.refundInitiatedAt)"
            class="mt-4 refund-section pa-4 rounded-lg"
          >
            <div class="d-flex align-center mb-2">
              <v-icon size="18" color="#10B981" class="mr-2"
                >mdi-cash-refund</v-icon
              >
              <span class="refund-title">Refund Details</span>
            </div>
            <v-row no-gutters>
              <v-col
                cols="12"
                sm="6"
                v-if="storage.refundStatus"
                class="mb-2 mb-sm-0"
              >
                <span class="r-label">Refund Status</span>
                <span class="r-value">{{ storage.refundStatus }}</span>
              </v-col>
              <v-col cols="12" sm="6" v-if="storage.refundInitiatedAt">
                <span class="r-label">Initiated On</span>
                <span class="r-value">{{ new Date(storage.refundInitiatedAt).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }) }}</span>
              </v-col>
            </v-row>
          </div>

          <!-- Status & Actions -->
          <div class="mt-4 d-flex align-center justify-space-between flex-wrap">
            <div class="d-flex align-center">
              <span class="status-label mr-2">Status:</span>
              <v-chip
                small
                label
                dark
                :color="getStatusColor(storage.orderStatus)"
                class="status-badge"
              >
                {{ storage.orderStatus }}
              </v-chip>
            </div>
            
            <div class="d-flex align-center gap-2">
              <v-btn
                v-if="storage.orderStatus == 'Delivered'"
                text
                small
                color="#3EA56E"
                class="font-weight-bold"
                target="_blank"
                :href="baseURL + 'order/invoice/pdf?orderId=' + storage.orderId + '&sellerId=' + storage.sellerId._id"
              >
                <v-icon left size="16">mdi-file-download-outline</v-icon>
                Invoice
              </v-btn>
              
              <v-btn
                v-if="storage.orderStatus == 'Pending' || storage.orderStatus == 'Order Confirmed'"
                depressed
                small
                outlined
                color="#EF4444"
                rounded
                @click="cancelProduct(storage)"
              >
                Cancel Item
              </v-btn>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
// import axios from "axios";
export default {
  props: ["storage", "order"],
  data() {
    return {
      appLoading: false,
      timeout: 5000,
      msg: "",
      ServerError: false,
      showSnackBar: false,
      orderStatus: "Pending",
      orderStatuses: [
        { name: "Pending", value: "Pending" },
        { name: "Order Confirmed", value: "Order Confirmed" },
        { name: "Cancel", value: "Cancel" },
        { name: "Shipped", value: "Shipped" },
        { name: "Out For Delivery", value: "Out For Delivery" },
        { name: "Delivered", value: "Delivered" },
        { name: "Cancelled", value: "Cancelled" },
        { name: "Returned", value: "Returned" },
      ],
      cancelDialogue: false,
    };
  },
  methods: {
     setRating(item) {
      {
        this.$emit("stepper", {
          ref: "addrating",
          orderitemId: item._id,
          productid: item.productId._id,
          rating: item.productId.rating,
          comment: item.productId.comment,
        });
      }
    },
    cancelProduct(item) {
      this.$emit("stepper", {
        ref: "cancelProduct",
        type: "cancell",
        id: item._id,
        orderId: item.orderId
      });
      this.cancelDialogue = false;
    },
    getStatusColor(status) {
      switch (status?.toLowerCase()) {
        case "delivered":
          return "#10B981";
        case "pending":
          return "#F59E0B";
        case "cancelled":
          return "#EF4444";
        case "shipped":
          return "#3B82F6";
        case "order confirmed":
          return "#3EA56E";
        default:
          return "#64748B";
      }
    },
  },
};
</script>

<style scoped>
.product-image {
  border: 1px solid #f1f5f9;
  background: white;
}

.product-name {
  font-family: "poppinssemibold", sans-serif;
  font-size: 18px;
  color: #1e293b;
  margin: 0;
  transition: color 0.3s ease;
}

.product-name:hover {
  color: #3ea56e;
}

.track-btn {
  font-family: "poppinsmedium", sans-serif;
  text-transform: none;
  letter-spacing: 0.3px;
  font-size: 13px;
}

.p-label {
  display: block;
  font-family: "poppinsmedium", sans-serif;
  font-size: 12px;
  color: #94a3b8;
  text-transform: uppercase;
  margin-bottom: 2px;
}

.p-value {
  font-family: "poppinssemibold", sans-serif;
  font-size: 15px;
  color: #1e293b;
}

.highlight .p-value {
  color: #3ea56e;
  font-size: 17px;
}

.rating-section {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.rating-title {
  font-family: "poppinssemibold", sans-serif;
  font-size: 14px;
  color: #475569;
}

.review-input ::v-deep fieldset {
  border-color: #cbd5e1;
}

.status-label {
  font-family: "poppinsmedium", sans-serif;
  font-size: 14px;
  color: #64748b;
}

.status-badge {
  font-family: "poppinssemibold", sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 11px;
}

.gap-2 {
  gap: 8px;
}

.shipment-section {
  background: #eff6ff;
  border: 1px solid #dbeafe;
}

.shipment-title {
  font-family: "poppinssemibold", sans-serif;
  font-size: 14px;
  color: #1e40af;
}

.s-label {
  display: block;
  font-family: "poppinsmedium", sans-serif;
  font-size: 11px;
  color: #1e40af;
  text-transform: uppercase;
  margin-bottom: 2px;
  opacity: 0.7;
}

.s-value {
  font-family: "poppinssemibold", sans-serif;
  font-size: 14px;
  color: #1e3a8a;
}

.refund-section {
  background: #f0fdf4;
  border: 1px solid #dcfce7;
}

.refund-title {
  font-family: "poppinssemibold", sans-serif;
  font-size: 14px;
  color: #166534;
}

.r-label {
  display: block;
  font-family: "poppinsmedium", sans-serif;
  font-size: 11px;
  color: #166534;
  text-transform: uppercase;
  margin-bottom: 2px;
  opacity: 0.7;
}

.r-value {
  font-family: "poppinssemibold", sans-serif;
  font-size: 14px;
  color: #14532d;
}

@media (max-width: 600px) {
  .product-name {
    font-size: 16px;
  }
}
</style>